import { v1 as uuidv1 } from "uuid";
import { isEmpty } from "lodash";
import { memo, useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { uploadPublicDataSnapshot } from "store/processes/actions/dataImport/publicDataImportActions";

import ButtonGroup from "components/ui/Button/ButtonGroup";
import Button from "components/ui/Button";
import UploadFile from "components/ui/Input/UploadFile";

import { isNullOrWhitespace } from "utils/string";

import { ClientModalProps } from "layouts/Modal/HomeDashboardModal/types";

const MarketData = memo(({ client, onCancel }: ClientModalProps) => {
    const dispatch = useDispatch();

    const [files, setFiles] = useState<File[]>([]);

    const onDropFile = useCallback((event) => {
        setFiles(event);
    }, []);

    const onRemoveFile = useCallback((files) => {
        setFiles(files);
    }, []);

    const onImportClick = useCallback(() => {
        for (const file of files) {
            if (isNullOrWhitespace(file.name)) {
                return;
            }

            dispatch(
                uploadPublicDataSnapshot({
                    id: uuidv1(),
                    idClient: client.id,
                    file,
                })
            );
        }

        onCancel?.();
    }, [client.id, files, onCancel, dispatch]);

    return (
        <>
            <div className="flex-column modal-padding market-data">
                <UploadFile
                    required
                    label="Upload public data"
                    multiple
                    files={files}
                    onDrop={onDropFile}
                    onRemove={(files) => onRemoveFile(files)}
                />
            </div>
            <ButtonGroup className="justify-end modal-actions">
                <Button primary disabled={isEmpty(files)} onClick={onImportClick}>
                    Import
                </Button>
                <Button onClick={onCancel}>Cancel</Button>
            </ButtonGroup>
        </>
    );
});

export default MarketData;
